export default __webpack_public_path__ + "static/media/parity-logo-dark.a40a8f14.svg";